module.exports = __webpack_public_path__ + "static/media/LookUp.svg";